//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'vx-input-group',
  props: {
    prependClasses: {
      type: String
    },
    appendClasses: {
      type: String
    }
  }
};